import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SubscriptionRoute = ({ children }) => {
  const { hasActiveSubscription, loading, user, isAuthenticated } = useAuth();

  // Add logging to track subscription status changes
  // console.log("🔐 SubscriptionRoute render:", {
  //   loading,
  //   isAuthenticated,
  //   hasActiveSubscription,
  //   userEmail: user?.email,
  //   subscriptionPlan: user?.subscription_plan,
  //   subscriptionValidUntil: user?.subscription_valid_until
  // });

  // Show loading spinner while checking authentication and subscription
  if (loading) {
    // console.log("⏳ SubscriptionRoute: Loading state");
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
      </div>
    );
  }

  // First check: redirect to login if not authenticated
  if (!isAuthenticated) {
    // console.log("🚫 SubscriptionRoute: Not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // Second check: ensure user data exists
  if (!user) {
    // console.log("⚠️ SubscriptionRoute: Authenticated but no user data, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // Third check: redirect to pricing page if no active subscription
  if (!hasActiveSubscription) {
    // console.log("🚫 SubscriptionRoute: No active subscription, redirecting to pricing");
    return <Navigate to="/pricing" replace />;
  }

  // Render children if user has active subscription
  // console.log("✅ SubscriptionRoute: Active subscription found, rendering protected content");
  return children;
};

export default SubscriptionRoute;
